<template>
  <div class="commissionSharing">
    <NavBar title="购买云手机" />
    <div class="mainBox">
      <div class="imgs">
        <img src="@/assets/yaoqing/toutu.png" alt="" />
      </div>
      <div class="main">
        <div v-if="userdata" class="users">
          <img
            :src="
              userdata.avatar
                ? userdata.avatar
                : require('@/assets/icons/defaultAvatar.png')
            "
            alt=""
          />
          <div class="users_name">
            <p class="names">{{ userdata.nickName }}</p>
            <p>ID:{{ userdata.id }}</p>
          </div>
          <!-- <button class="user_tuichu" @click="tuchudenglu">退出</button> -->
        </div>
        <p class="userinfo">
          【{{
            inviterUsername ? inviterUsername : "迅流云"
          }}】推荐您使用迅流云手机！
        </p>
        <div v-if="userCountlist" class="userrenshu">
          已有<span>{{ userCountlist.allUser }}</span> 用户在使用迅流云
        </div>
        <!-- 特惠 -->
        <div class="tehui">
          <div class="title_tehui">
            <img src="@/assets/yaoqing/Group 78.png" alt="" />
          </div>
          <div class="tehui_peizhi">
            <ul>
              <li v-for="(item, index) in PackageLists" :key="index">
                <span class="tianshu">{{ item.buyDay }}天</span>
                <p class="p_xitong">{{ item.skuName }}</p>
                <p class="p_jine">
                  ¥
                  <span>{{ item.salePrice }}</span>
                </p>
                <p class="p_peizhi">
                  {{ item.memorySize }}运存 {{ item.storageSize }}存储
                </p>
                <van-button
                  :disabled="!item.buyEnabled"
                  class="goumai_btn"
                  @click="lijigoumai(item)"
                  >立即购买</van-button
                >
              </li>
            </ul>
            <div v-if="!newpackage" class="ckgd_th" @click="chakangengduo(1)">
              查看更多
              <img src="@/assets/imgs/groupingBottom1.png" alt="" />
            </div>
            <div v-else class="ckgd_th" @click="chakangengduo(3)">
              收起
              <img src="@/assets/imgs/groupingTop1.png" alt="" />
            </div>
          </div>
        </div>
        <!-- 套餐 -->
        <div class="tehui taochan">
          <div class="title_tehui">
            <img src="@/assets/yaoqing/taochanfenyong.png" alt="" />
          </div>
          <div class="taochan_peizhi">
            <ul>
              <li v-for="(item, index) in recommendLists" :key="index">
                <div class="taochan_top">
                  <span class="tianshu">{{ item.buyDay }}天</span>
                  <img
                    v-if="item.vipCode == 'VIP1'"
                    src="@/assets/yaoqing/biaozhun.png"
                    alt=""
                  />
                  <img
                    v-else-if="item.vipCode == 'VIP2'"
                    src="@/assets/yaoqing/changwan.png"
                    alt=""
                  />
                  <img
                    v-else-if="item.vipCode == 'VIP3'"
                    src="@/assets/yaoqing/aoran.png"
                    alt=""
                  />
                  <img
                    v-else-if="item.vipCode == 'VIP4'"
                    src="@/assets/yaoqing/zhizun.png"
                    alt=""
                  />
                  <img v-else src="@/assets/yaoqing/dingzhi.png" alt="" />
                  <div class="taochan_sj">
                    <p>{{ item.skuName }}</p>
                    <p class="p_jine">
                      <span class="span1">¥</span>
                      <span v-if="item.salePrice" class="span2">{{
                        (item.salePrice + "").indexOf(".")
                          ? (item.salePrice + ".0").split(".")[0]
                          : (item.salePrice + "").split(".")[0]
                      }}</span>
                      <span v-else class="span2">00</span>
                      <span class="span3"
                        >.{{
                          (item.salePrice + "").indexOf(".")
                            ? (item.salePrice + ".0").split(".")[1]
                            : (item.salePrice + "").split(".")[1]
                        }}</span
                      >
                    </p>
                  </div>
                </div>
                <div class="taochan_foot">
                  <button class="xufei_btn" @click="xufeiphone(item)">
                    立即续费
                  </button>
                  <button class="goumai_btn" @click="lijigoumai(item)">
                    立即购买
                  </button>
                </div>
              </li>
            </ul>
            <div v-if="!recommend" class="ckgd_th" @click="chakangengduo(2)">
              查看更多
              <img src="@/assets/imgs/groupingBottom1.png" alt="" />
            </div>
            <div v-else class="ckgd_th" @click="chakangengduo(4)">
              收起
              <img src="@/assets/imgs/groupingTop1.png" alt="" />
            </div>
          </div>
        </div>
        <!-- 体验 -->
        <div class="tehui tiyan">
          <div class="title_tehui">
            <img src="@/assets/yaoqing/yaoninshiyong.png" alt="" />
          </div>
          <div class="tiyan_xingneng">
            <div class="tiyan_dianliu">
              <img src="@/assets/yaoqing/shouyou24h.png" alt="" />
              <div class="tiyan_left">
                <p class="title_name">手游24小时免电免流</p>
                <p>
                  不断网不耗电，7*24小时全天在线
                  拒绝手机没电！告别流量报警！防止手机发烫，做手机最场景的守护者
                </p>
              </div>
            </div>
            <div class="tiyan_dianliu">
              <div class="tiyan_left tiyan_right">
                <p class="title_name">一机多开 简单操作</p>
                <p>
                  游戏应用轻松多开，一台手机变多台，批量管理更便捷，随时随地实时预览所以应用进度
                </p>
              </div>
              <img src="@/assets/yaoqing/yijiduokai.png" alt="" />
            </div>
            <div class="tiyan_dianliu">
              <img src="@/assets/yaoqing/zidong.png" alt="" />
              <div class="tiyan_left">
                <p class="title_name">自动挂机 解放双手</p>
                <p>
                  云端智能运行，手游神器，快速养号，轻松一键任务自动挂机，实现自动化，便捷轻松
                </p>
              </div>
            </div>
            <div class="tiyan_dianliu">
              <div class="tiyan_left tiyan_right">
                <p class="title_name">免ROOT 随心畅玩</p>
                <p>
                  自带免ROOT功能，可自选ROOT开关，随心搭配游戏助手不用担心病毒对核心数据造成破坏，放心畅玩
                </p>
              </div>
              <img src="@/assets/yaoqing/mianROOT .png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录弹框 -->
    <van-popup class="zhuce_denglu" v-model="show" closeable>
      <p>输入手机号注册登录</p>
      <van-cell-group>
        <van-field
          v-model="phone"
          type="tel"
          placeholder="请输入手机号"
          clearable
          maxlength="11"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="yanzhengma"
          placeholder="请输入验证码"
          maxlength="6"
        >
          <template #button>
            <van-button
              v-if="!yzm_daojishi"
              size="small"
              class="yzm_btn"
              @click="getyanzhengma"
              >获取验证码</van-button
            >
            <van-button v-else size="small" class="yzm_btns" :disabled="true"
              >{{ countDown }}S重新发送</van-button
            >
          </template>
        </van-field>
      </van-cell-group>
      <div class="denglu_xieyi">
        <van-checkbox v-model="checked"
          >我已阅读并同意<a
            href="http://static.aixunliu.com/app/user_agreement.html"
            >《用户使用协议》</a
          >和<a href="http://static.aixunliu.com/app/privacy_policy.html"
            >《隐私政策》</a
          >内所有条款</van-checkbox
        >
      </div>
      <van-button
        type="info"
        class="denglu_btn"
        :disabled="checked & (yanzhengma != '') & (phone != '') ? false : true"
        :color="checked & (yanzhengma != '') & (phone != '') ? '' : '#B2B4BA'"
        @click="mobiledenglu"
        >立即登录</van-button
      >
    </van-popup>
    <!-- 支付弹框 -->
    <van-popup
      v-model="zhifu_show"
      closeable
      round
      position="bottom"
      class="zhifu"
    >
      <p>购买云手机</p>
      <div class="zhifu_main">
        <van-cell-group>
          <van-cell :value="'¥' + goumaiinfo.salePrice">
            <template #title>
              <span class="zhifu_taochan">{{ goumaiinfo.skuName }}</span>
              <span class="zhifu_tianshu">{{ goumaiinfo.buyDay }}天</span>
            </template>
          </van-cell>
          <van-cell title="云手机系统" :value="goumaiinfo.skuName" />
        </van-cell-group>
        <div class="zhifu_fs">
          <p>请选择支付方式</p>
          <div class="xuanze_zf">
            <van-radio-group v-model="payType">
              <van-cell-group>
                <van-cell clickable @click="payType = 5">
                  <template #title>
                    <img src="@/assets/yaoqing/weixin.png" alt="" />
                    <span>微信</span>
                  </template>
                  <template #right-icon>
                    <van-radio :name="5" />
                  </template>
                </van-cell>
                <van-cell clickable @click="payType = 6">
                  <template #title>
                    <img src="@/assets/yaoqing/zhifubao.png" alt="" />
                    <span>支付宝</span>
                  </template>
                  <template #right-icon>
                    <van-radio :name="6" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
        </div>

        <div class="goumai_sl">
          <span>请选择购买数量</span>
          <van-stepper v-model="stepperval" />
        </div>
        <div class="xieyi">
          购买前请阅读
          <a href="http://static.aixunliu.com/app/vip.html">《服务协议》</a>
        </div>
        <div class="shouyintai">
          <div class="main_zhifu">
            <p>
              <span class="span1">¥</span>
              <span v-if="goumaiinfo.salePrice" class="span2">{{
                (goumaiinfo.salePrice + "").indexOf(".")
                  ? (goumaiinfo.salePrice * stepperval + ".0").split(".")[0]
                  : (goumaiinfo.salePrice * stepperval + "").split(".")[0]
              }}</span>
              <span v-else class="span2">00</span>
              <span class="span3"
                >.{{
                  (goumaiinfo.salePrice + "").indexOf(".")
                    ? (goumaiinfo.salePrice * stepperval + ".0").split(".")[1]
                    : (goumaiinfo.salePrice * stepperval + "").split(".")[1]
                }}</span
              >
            </p>
            <button class="btn" @click="getordercreate(goumaiinfo, 1)">
              确认购买并支付
            </button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 续费弹框 -->
    <van-popup
      v-model="xufei_show"
      closeable
      round
      position="bottom"
      class="zhifu"
    >
      <p>续费云手机</p>
      <div class="zhifu_main">
        <van-cell-group>
          <van-cell :value="'¥' + xufeiinfo.salePrice">
            <template #title>
              <span class="zhifu_taochan">{{ xufeiinfo.skuName }}</span>
              <span class="zhifu_tianshu">{{ xufeiinfo.buyDay }}天</span>
            </template>
          </van-cell>
          <van-cell
            title="续费云手机"
            v-if="instanceList[0]"
            :value="instanceList[0].instanceName"
            is-link
            @click="xuanzexufei"
          />
        </van-cell-group>
        <div class="zhifu_fs">
          <p>请选择支付方式</p>
          <div class="xuanze_zf">
            <van-radio-group v-model="payType">
              <van-cell-group>
                <van-cell clickable @click="payType = 5">
                  <template #title>
                    <img src="@/assets/yaoqing/weixin.png" alt="" />
                    <span>微信</span>
                  </template>
                  <template #right-icon>
                    <van-radio :name="5" />
                  </template>
                </van-cell>
                <van-cell clickable @click="payType = 6">
                  <template #title>
                    <img src="@/assets/yaoqing/zhifubao.png" alt="" />
                    <span>支付宝</span>
                  </template>
                  <template #right-icon>
                    <van-radio :name="6" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
        </div>
        <div class="xieyi">
          购买前请阅读
          <a href="http://static.aixunliu.com/app/vip.html">《服务协议》</a>
        </div>
        <div class="shouyintai">
          <div class="main_zhifu">
            <p>
              <span class="span1">¥</span>
              <span v-if="xufeiinfo.salePrice" class="span2">{{
                (xufeiinfo.salePrice + "").indexOf(".")
                  ? (xufeiinfo.salePrice * renewIds.length + ".0").split(".")[0]
                  : (xufeiinfo.salePrice * renewIds.length + "").split(".")[0]
              }}</span>
              <span v-else class="span2">00</span>
              <span class="span3"
                >.{{
                  (xufeiinfo.salePrice + "").indexOf(".")
                    ? (xufeiinfo.salePrice * renewIds.length + ".0").split(
                        "."
                      )[1]
                    : (xufeiinfo.salePrice * renewIds.length + "").split(".")[1]
                }}</span
              >
            </p>
            <button class="btn" @click="getordercreate(xufeiinfo, 2)">
              确认购买并支付
            </button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 选择多台设备 -->
    <van-popup
      v-model="xuanzexufei_show"
      closeable
      round
      position="bottom"
      class="shebei"
    >
      <p>选择续费云手机</p>
      <div class="shebei_main">
        <van-checkbox-group
          v-model="renewIds"
          class="shebei_check"
          ref="checkboxGroup"
        >
          <van-cell-group>
            <van-cell
              v-for="(item, index) in instanceList"
              clickable
              :key="index"
              @click="toggle(index)"
            >
              <template #title>
                <div class="shebei_title">
                  <img
                    v-if="xufeiinfo.vipCode == 'VIP1'"
                    src="@/assets/yaoqing/biaozhun.png"
                    alt=""
                  />
                  <img
                    v-else-if="xufeiinfo.vipCode == 'VIP2'"
                    src="@/assets/yaoqing/changwan.png"
                    alt=""
                  />
                  <img
                    v-else-if="xufeiinfo.vipCode == 'VIP3'"
                    src="@/assets/yaoqing/aoran.png"
                    alt=""
                  />
                  <img
                    v-else-if="xufeiinfo.vipCode == 'VIP4'"
                    src="@/assets/yaoqing/zhizun.png"
                    alt=""
                  />
                  <img v-else src="@/assets/yaoqing/dingzhi.png" alt="" />
                  <div class="shebei_content">
                    <p class="p1">{{ item.instanceName }}</p>
                    <p class="p2">剩余时间:{{ item.expireTime }}</p>
                  </div>
                </div>
              </template>
              <template #right-icon>
                <van-checkbox :name="item.id" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <div class="shebei_foot">
          <van-checkbox
            class="xuanze_quanxuan"
            v-model="quanxuans"
            @click="quanxuan"
            >全选</van-checkbox
          >
          <button class="xuanze_shebei" @click="querenxuan">确认</button>
        </div>
      </div>
    </van-popup>
    <van-dialog
      v-model="endShow"
      title="提示"
      :showCancelButton="false"
      confirmButtonText="回到主页"
      theme="round-button"
      @confirm="endPageHome"
    >
      <div style="margin: 12px 0">活动已结束</div>
    </van-dialog>
  </div>
</template>
  
  <script>
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
import { vipinstance } from "@/api/index.js";
import { getsendCode, mobileLogin } from "@/api/login";
import { setToken, setData } from "@/utils/auth";
import { mapState, mapMutations } from "vuex";
import {
  commissionpackagelist,
  getopenId,
  userCountlist,
  ordercreate,
} from "@/api/buy";

export default {
  name: "CommissionSharing",
  components: {
    NavBar,
  },
  data() {
    return {
      combo: {},
      phone: "",
      payType: 5,
      show: false,
      timer: null, // 定时器
      userdata: null,
      countDown: 60, // 倒计时时间
      yanzhengma: "",
      stepperval: 1,
      checked: false,
      zhifu_show: false,
      yzm_daojishi: false,
      newPackageList: [],
      PackageLists: [],
      recommendLists: [],
      recommendPackageList: [],
      newpackage: false,
      recommend: false,
      xufei_show: false,
      xuanzexufei_show: false,
      goumaiinfo: {},
      xufeiinfo: {},
      inviterUserId: null,
      inviterUsername: "",
      renewIds: [],
      instanceList: [],
      quanxuans: false,
      userCountlist: null,
      openld: null,
      getCodeNum: 0,
      endShow: false,
      data: {
        newPackageList: [
          {
            id: 23,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型30天",
            originPrice: 86.0,
            salePrice: 58.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠28元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 1,
            vipName: null,
          },
          {
            id: 39,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型30天",
            originPrice: 36.0,
            salePrice: 28.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠8元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 2,
            vipName: null,
          },
          {
            id: 3,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V8",
            skuId: 1,
            skuName: "标准型-安卓8",
            packageName: "标准型30天",
            originPrice: 36.0,
            salePrice: 28.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠8元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "3G",
            storageSize: "30G",
            h5Sort: 3,
            vipName: null,
          },
          {
            id: 27,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V8",
            skuId: 5,
            skuName: "傲然型-安卓8",
            packageName: "傲然型30天",
            originPrice: 98.0,
            salePrice: 80.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠18元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 4,
            vipName: null,
          },
          {
            id: 1435,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V12",
            skuId: 94,
            skuName: "标准型-安卓12",
            packageName: "标准型30天",
            originPrice: 38.0,
            salePrice: 30.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠8元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "",
            storageSize: "",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 444,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型90天",
            originPrice: 98.0,
            salePrice: 80.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠18元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 486,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V8",
            skuId: 1,
            skuName: "标准型-安卓8",
            packageName: "标准型90天",
            originPrice: 98.0,
            salePrice: 80.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠18元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "3G",
            storageSize: "30G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 487,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型90天",
            originPrice: 136.0,
            salePrice: 116.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠20元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 489,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V8",
            skuId: 3,
            skuName: "畅玩型-安卓8",
            packageName: "畅玩型90天",
            originPrice: 168.0,
            salePrice: 122.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠46元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 490,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型90天",
            originPrice: 196.0,
            salePrice: 167.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠29元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 491,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V8",
            skuId: 5,
            skuName: "傲然型-安卓8",
            packageName: "傲然型90天",
            originPrice: 286.0,
            salePrice: 240.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠46元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 492,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型90天",
            originPrice: 368.0,
            salePrice: 317.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠51元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 1437,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V12",
            skuId: 94,
            skuName: "标准型-安卓12",
            packageName: "标准型90天",
            originPrice: 100.0,
            salePrice: 82.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠18元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "",
            storageSize: "",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3130,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型30天",
            originPrice: 33.0,
            salePrice: 25.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠8元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3255,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型30天",
            originPrice: 53.0,
            salePrice: 35.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠18元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3260,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型30天",
            originPrice: 83.0,
            salePrice: 55.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠28元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3264,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型30天",
            originPrice: 145.0,
            salePrice: 118.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠27元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3132,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型90天",
            originPrice: 95.0,
            salePrice: 77.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠18元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3257,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型90天",
            originPrice: 133.0,
            salePrice: 113.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠20元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3262,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型90天",
            originPrice: 193.0,
            salePrice: 164.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠29元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3266,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型90天",
            originPrice: 365.0,
            salePrice: 314.0,
            buyDay: 90,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠51元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 17,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V8",
            skuId: 3,
            skuName: "畅玩型-安卓8",
            packageName: "畅玩型30天",
            originPrice: 62.0,
            salePrice: 39.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠23元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "64G",
            h5Sort: 240,
            vipName: null,
          },
          {
            id: 10,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型30天",
            originPrice: 56.0,
            salePrice: 38.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠18元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 250,
            vipName: null,
          },
          {
            id: 32,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型30天",
            originPrice: 148.0,
            salePrice: 121.0,
            buyDay: 30,
            promotionType: 1,
            promotionName: "首充优惠",
            promotionDescription: "新人首充优惠27元",
            limitCount: 20,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 260,
            vipName: null,
          },
        ],
        recommendPackageList: [
          {
            id: 5,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V8",
            skuId: 1,
            skuName: "标准型-安卓8",
            packageName: "标准型30天",
            originPrice: 36.0,
            salePrice: 36.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "3G",
            storageSize: "30G",
            h5Sort: 5,
            vipName: null,
          },
          {
            id: 41,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型30天",
            originPrice: 36.0,
            salePrice: 36.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 6,
            vipName: null,
          },
          {
            id: 30,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V8",
            skuId: 5,
            skuName: "傲然型-安卓8",
            packageName: "傲然型30天",
            originPrice: 98.0,
            salePrice: 98.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 8,
            vipName: null,
          },
          {
            id: 25,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型30天",
            originPrice: 86.0,
            salePrice: 86.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 9,
            vipName: null,
          },
          {
            id: 19,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V8",
            skuId: 3,
            skuName: "畅玩型-安卓8",
            packageName: "畅玩型30天",
            originPrice: 62.0,
            salePrice: 62.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "64G",
            h5Sort: 50,
            vipName: null,
          },
          {
            id: 12,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型30天",
            originPrice: 56.0,
            salePrice: 56.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 60,
            vipName: null,
          },
          {
            id: 35,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型30天",
            originPrice: 148.0,
            salePrice: 148.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 70,
            vipName: null,
          },
          {
            id: 3526,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V8",
            skuId: 1,
            skuName: "标准型-安卓8",
            packageName: "标准型66天",
            originPrice: 72.0,
            salePrice: 56.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "3G",
            storageSize: "30G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 229,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V8",
            skuId: 1,
            skuName: "标准型-安卓8",
            packageName: "标准型90天",
            originPrice: 98.0,
            salePrice: 98.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "3G",
            storageSize: "30G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3620,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型66天",
            originPrice: 112.0,
            salePrice: 87.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 230,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型90天",
            originPrice: 136.0,
            salePrice: 136.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3938,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型66天",
            originPrice: 109.0,
            salePrice: 84.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3254,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型30天",
            originPrice: 53.0,
            salePrice: 53.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3256,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型90天",
            originPrice: 133.0,
            salePrice: 133.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3258,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型365天",
            originPrice: 405.0,
            salePrice: 405.0,
            buyDay: 365,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3630,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V8",
            skuId: 3,
            skuName: "畅玩型-安卓8",
            packageName: "畅玩型66天",
            originPrice: 124.0,
            salePrice: 97.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 231,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V8",
            skuId: 3,
            skuName: "畅玩型-安卓8",
            packageName: "畅玩型90天",
            originPrice: 168.0,
            salePrice: 168.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "64G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3629,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型66天",
            originPrice: 172.0,
            salePrice: 118.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 232,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型90天",
            originPrice: 196.0,
            salePrice: 196.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3939,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型66天",
            originPrice: 169.0,
            salePrice: 115.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3259,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型30天",
            originPrice: 83.0,
            salePrice: 83.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3261,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            skuId: 4,
            skuName: "傲然型-安卓10",
            packageName: "傲然型90天",
            originPrice: 193.0,
            salePrice: 193.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 233,
            vipId: 3,
            vipCode: "VIP3",
            deviceVersionCode: "V8",
            skuId: 5,
            skuName: "傲然型-安卓8",
            packageName: "傲然型90天",
            originPrice: 286.0,
            salePrice: 286.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "8G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 4146,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型66天",
            originPrice: 296.0,
            salePrice: 219.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 214,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型90天",
            originPrice: 368.0,
            salePrice: 368.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3940,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型66天",
            originPrice: 293.0,
            salePrice: 216.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3263,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型30天",
            originPrice: 145.0,
            salePrice: 145.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3265,
            vipId: 4,
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            skuId: 6,
            skuName: "至尊型-安卓10",
            packageName: "至尊型90天",
            originPrice: 365.0,
            salePrice: 365.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "16G",
            storageSize: "128G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3525,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型66天",
            originPrice: 72.0,
            salePrice: 56.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 221,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型90天",
            originPrice: 98.0,
            salePrice: 98.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 227,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型365天",
            originPrice: 296.0,
            salePrice: 296.0,
            buyDay: 365,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 4116,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型66天",
            originPrice: 69.0,
            salePrice: 53.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3129,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型30天",
            originPrice: 33.0,
            salePrice: 33.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3131,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型90天",
            originPrice: 95.0,
            salePrice: 95.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3133,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            skuId: 7,
            skuName: "标准型-安卓10",
            packageName: "标准型365天",
            originPrice: 293.0,
            salePrice: 293.0,
            buyDay: 365,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "45G",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 3631,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V12",
            skuId: 94,
            skuName: "标准型-安卓12",
            packageName: "标准型66天",
            originPrice: 74.0,
            salePrice: 58.0,
            buyDay: 66,
            promotionType: 98,
            promotionName: "缤纷暖冬 诞愿有礼",
            promotionDescription: "限时买60天送6天",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "",
            storageSize: "",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 1434,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V12",
            skuId: 94,
            skuName: "标准型-安卓12",
            packageName: "标准型30天",
            originPrice: 38.0,
            salePrice: 38.0,
            buyDay: 30,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "",
            storageSize: "",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 1436,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V12",
            skuId: 94,
            skuName: "标准型-安卓12",
            packageName: "标准型90天",
            originPrice: 100.0,
            salePrice: 100.0,
            buyDay: 90,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "",
            storageSize: "",
            h5Sort: 99,
            vipName: null,
          },
          {
            id: 1,
            vipId: 1,
            vipCode: "VIP1",
            deviceVersionCode: "V8",
            skuId: 1,
            skuName: "标准型-安卓8",
            packageName: "标准型365天",
            originPrice: 296.0,
            salePrice: 296.0,
            buyDay: 365,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "3G",
            storageSize: "30G",
            h5Sort: 300,
            vipName: null,
          },
          {
            id: 15,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V8",
            skuId: 3,
            skuName: "畅玩型-安卓8",
            packageName: "畅玩型365天",
            originPrice: 468.0,
            salePrice: 468.0,
            buyDay: 365,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "4G",
            storageSize: "64G",
            h5Sort: 302,
            vipName: null,
          },
          {
            id: 8,
            vipId: 2,
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            skuId: 2,
            skuName: "畅玩型-安卓10",
            packageName: "畅玩型365天",
            originPrice: 408.0,
            salePrice: 408.0,
            buyDay: 365,
            promotionType: 0,
            promotionName: "正常销售",
            promotionDescription: "",
            limitCount: 1000,
            buyEnabled: true,
            memorySize: "5.3G",
            storageSize: "64G",
            h5Sort: 303,
            vipName: null,
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    // 支付失败调试发现未执行getCode()
    let that = this;
    this.userdata = JSON.parse(localStorage.getItem("data"));
    this.inviterUserId = this.$route.query.inviterUserId;
    this.inviterUsername = this.$route.query.inviterUsername;
    this.getcommissionlist();
    this.getuserCountlist();
    const isWeixinBrowser = /micromessenger/i.test(navigator.userAgent);
    if (isWeixinBrowser) {
      if (this.userdata != null) {
        let opend = sessionStorage.getItem("openid");
        if (opend == null || opend == "undefined" || !opend || opend == "0") {
          that.getCode();
        } else {
          that.openld = opend;
          // that.getCode();
        }
      }
    }
  },

  methods: {
    ...mapMutations("user", ["SET_TOKEN", "SET_DATA"]),
    endPageHome() {
      this.$router.push("/");
    },
    // 获取code
    getCode() {
      var str = this.$route.query.code;
      this.getCodeNum++;
      if (str) {
        let data = {
          code: str,
        };
        // 走后端接口(把code传给后台，让后台根据code获取openID与用户信息) 通过code 获取openid
        getopenId(data).then((res) => {
          if (res.code == 200) {
            this.openld = res.msg;
            // Cookies.set("openid", res.msg);
            sessionStorage.setItem("openid", res.msg);
          } else {
            Toast("获取失败！");
          }
        });
      } else {
        if (
          typeof WeixinJSBridge === "object" &&
          typeof WeixinJSBridge.invoke === "function"
        ) {
          var appid = "wx909fcb382f6004ca";
          var redirect_uri = window.location.href;
          var newRedirect = encodeURIComponent(redirect_uri); // 此处需要将你的回调页面进行转码，此方法直接使用
          location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appid +
            "&redirect_uri=" +
            newRedirect +
            "&response_type=code&scope=snsapi_userinfo&state=333&connect_redirect=1#wechat_redirect";
        }
      }
      this.setTime = setTimeout(() => {
        if (!str && this.getCodeNum <= 5) {
          this.getCode();
        }
      }, 1000);
    },
    // 立即购买
    lijigoumai(e_iam) {
      if (this.userdata == null) {
        this.show = true;
      } else {
        this.zhifu_show = true;
        this.goumaiinfo = e_iam;
      }
    },
    // 立即续费
    xufeiphone(e_iam) {
      if (this.userdata == null) {
        this.show = true;
      } else {
        this.getvipinstance(e_iam.skuId);

        this.xufeiinfo = e_iam;
      }
    },
    xuanzexufei() {
      this.xuanzexufei_show = true;
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    // 查看更多
    chakangengduo(e) {
      if (e == 1) {
        this.newpackage = true;
        this.PackageLists = this.newPackageList;
      } else if (e == 2) {
        this.recommend = true;
        this.recommendLists = this.recommendPackageList;
      } else if (e == 3) {
        this.newpackage = false;
        this.PackageLists = this.newPackageList.slice(0, 4);
      } else if (e == 4) {
        this.recommend = false;
        this.recommendLists = this.recommendPackageList.slice(0, 6);
      }
    },
    // 获取套餐
    async getcommissionlist() {
      let that = this;
      let params = {};
      await commissionpackagelist(params).then((res) => {
        if (res.code == 200) {
          res.data = this.data;
          that.newPackageList = res.data.newPackageList;
          that.recommendPackageList = res.data.recommendPackageList;
          that.PackageLists = that.newPackageList.slice(0, 4);
          that.recommendLists = that.recommendPackageList.slice(0, 6);
        } else {
          if (res.code == 401) {
            this.show = true;
            localStorage.removeItem("token");
            localStorage.removeItem("data");
          }
        }
      });
    },
    // 获取当日注册人数
    async getuserCountlist() {
      let that = this;
      let params = {};
      await userCountlist(params).then((res) => {
        if (res.code == 200) {
          that.userCountlist = res.data;
        } else {
          if (res.code == 401) {
            this.show = true;
            localStorage.removeItem("token");
            localStorage.removeItem("data");
          }
        }
      });
    },
    // 获取验证码
    async getyanzhengma() {
      const phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        Toast("手机号错误！请重新输入");
      } else {
        let data = {
          mobile: this.phone,
          businessType: "login",
        };
        await getsendCode(data).then((res) => {
          if (res.code == 200) {
            this.yzm_daojishi = true;
            this.startCountDown();
            Toast("验证码已发送至您的手机");
          }
        });
      }
    },
    // 登录
    async mobiledenglu() {
      let that = this;
      const phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        Toast("手机号错误！请重新输入");
      } else {
        let data = {
          mobile: this.phone,
          code: this.yanzhengma,
        };
        await mobileLogin(data).then((res) => {
          if (res.code == 200) {
            res.data.loginType = "0";
            setToken(res.data.token);
            setData(res.data);
            that.SET_TOKEN(res.data.token);
            that.SET_DATA(JSON.stringify(res.data));
            this.$router.go(0);
          }
        });
      }
    },
    // 验证码倒计时
    startCountDown() {
      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          clearInterval(this.timer);
          this.yzm_daojishi = false;
          this.countDown = 60;
        }
      }, 1000);
    },
    // 创建订单并拉起支付
    async getordercreate(combo, ea) {
      Toast("参数配置有误");
      return;
      let that = this;
      if (that.payType != 6) {
        const isWeixinBrowser = /micromessenger/i.test(navigator.userAgent);
        if (isWeixinBrowser) {
          that.payType = 7;
        } else {
          that.payType = 5;
        }
      }
      let data = {
        packageId: combo.id,
        totalAmount:
          ea == 1
            ? combo.salePrice * this.stepperval
            : combo.salePrice * this.renewIds.length,
        count: ea == 1 ? this.stepperval : 1,
        payType: this.payType,
        renewId: null,
        renewIds: ea == 1 ? null : this.renewIds,
        inviterUserId: this.inviterUserId,
        skipUrl: "https://www.aixunliu.con/",
        openId: that.openld,
      };
      await ordercreate(data).then((res) => {
        if (res.code == 200) {
          if (that.payType == 6) {
            let div = document.querySelector("#payDiv");
            if (!div) {
              div = document.createElement("div");
              div.id = "payDiv";
              document.body.appendChild(div);
            }
            div.innerHTML = res.data.payUrl;
            document.forms[0].submit();
          }
          if (that.payType == 5) {
            if (this.$common.isAppleWebKit()) {
              location.href =
                res.data.payUrl +
                "&redirect_url=https://www.aixunliu.cn/wxMiddlePage";
            } else {
              location.href = res.data.payUrl;
            }
          }
          if (that.payType == 7) {
            that.onBridgeReady(res.data);
          }
        } else {
          Toast(res.msg);
          if (res.code == 401) {
            this.show = true;
            localStorage.removeItem("token");
            localStorage.removeItem("data");
          }
        }
      });
    },
    // 微信支付专用
    onBridgeReady(em) {
      var that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: "wx909fcb382f6004ca",
          timeStamp: em.timeStamp,
          nonceStr: em.nonce,
          package: "prepay_id=" + em.prepayId,
          signType: "RSA",
          paySign: em.sign, //支付签名
          amount: {
            total: em.totalAmount,
            currency: "CNY",
          },
        },
        function (res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            Toast("支付成功！");
            // that.$router.push({ path: "/resultpayment" });
          } else if (res.err_msg === "get_brand_wcpay_request:fail") {
            Toast(res.err_msg);
          }
        }
      );
    },

    // 获取设备
    async getvipinstance(e) {
      Toast("请先购买设备！");
      return;
      let data = {
        skuId: e,
      };
      await vipinstance(data).then((res) => {
        if (res.code == 200) {
          if (res.data.length >= 1) {
            this.xufei_show = true;
            this.instanceList = res.data;
            this.renewIds[0] = this.instanceList[0].id;
          } else {
            this.xufei_show = false;
            Toast("请先购买设备！");
          }
        } else {
          Toast(res.msg);
          if (res.code == 401) {
            this.show = true;
            localStorage.removeItem("token");
            localStorage.removeItem("data");
          }
        }
      });
    },
    // 全选反选
    quanxuan() {
      if (this.quanxuans == true) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll(false);
      }
    },
    // 确认选择
    querenxuan() {
      this.xuanzexufei_show = false;
    },
    tuchudenglu() {
      localStorage.removeItem("data");
      sessionStorage.removeItem("selectiveGroup");
      this.$router.go(0);
    },
  },
};
</script>
  
  <style lang="less" scoped>
.commissionSharing {
  display: flex;
  flex-direction: column;
  height: 100%;
  .mainBox {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    touch-action: manipulation;
    scrollbar-width: none;
  }
}
#app {
  background: #8acfef !important;
}
.top {
  height: 44px;
  /deep/.fanhui {
    display: none;
  }
}
.imgs {
  width: 100%;
  height: 430px;
  img {
    width: 100%;
    height: 100%;
  }
}
.main {
  padding: 0 16px 50px;
  background: #d7f3ff;
  .users {
    display: flex;
    align-items: center;
    padding: 16px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    border: 1px solid #ffffff;
    margin-bottom: 12px;
    img {
      width: 48px;
      height: 48px;
    }
    .users_name {
      flex: 1;
      text-align: left;
      margin-left: 15px;
      p {
        margin: 0;
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 16px;
      }
      .names {
        height: 28px;
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 28px;
      }
    }
    .user_tuichu {
      width: 80px;
      height: 34px;
      background: #f4fbff;
      border-radius: 17px 17px 17px 17px;
      opacity: 1;
      border: 1px solid #6ac6ff;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #1084ff;
    }
  }
  .userinfo {
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin: 0 0 12px;
  }
  .userrenshu {
    width: 100%;
    height: 32px;
    background-image: url("@/assets/yaoqing/Rectangle148.png");
    background-size: 100% 100%;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    span {
      font-size: 15px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff6627;
    }
  }
  .tehui {
    padding: 0 16px 16px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    .title_tehui {
      margin: 0 51px;
      height: 50px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tehui_peizhi {
      margin-top: 15px;
      ul {
        text-align: left;
        li {
          width: calc(50% - 6px);
          position: relative;
          text-align: center;
          display: inline-block;
          background-image: url("@/assets/yaoqing/youhuibeijing.png");
          background-size: 100% 100%;
          border-radius: 10px 10px 10px 10px;
          margin-bottom: 10px;
          padding-bottom: 10px;
          .tianshu {
            position: absolute;
            top: 0;
            left: 0;
            padding: 0 6px;
            height: 22px;
            background: linear-gradient(200deg, #ffa869 0%, #ff5719 100%);
            border-radius: 10px 1px 10px 1px;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 22px;
          }
          p {
            margin: 0;
          }
          .p_xitong {
            margin-top: 13px;
            height: 20px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
          .p_jine {
            margin-top: 6px;
            font-size: 20px;
            font-family: DIN Medium-Regular, DIN Medium;
            font-weight: 400;
            color: #1084ff;
            span {
              height: 49px;
              font-size: 40px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: #1084ff;
              line-height: 49px;
            }
          }
          .p_peizhi {
            margin-top: 4px;
            height: 20px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
          }
          .goumai_btn {
            margin: 28px 18px 0;
            height: 36px;
            background: linear-gradient(137deg, #00b2ff 0%, #0066ff 100%);
            box-shadow: inset 0px 4px 8px 0px #3ac0ff;
            border-radius: 18px 18px 18px 18px;
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            border: none;
          }
        }
        li:nth-child(2n) {
          margin-left: 12px;
        }
      }
    }
  }
  .taochan {
    margin-top: 10px;
    .taochan_peizhi {
      ul {
        li {
          padding: 16px;
          margin-bottom: 10px;
          background: #d7f3ff;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #acdffe;
          .taochan_top {
            position: relative;
            padding: 12px 16px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            display: flex;
            align-items: center;
            .tianshu {
              position: absolute;
              top: 0;
              right: 0;
              padding: 0 6px;
              height: 22px;
              background: linear-gradient(200deg, #ffa869 0%, #ff5719 100%);
              border-radius: 1px 8px 1px 8px;
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              line-height: 22px;
            }
            img {
              width: 44px;
              height: 44px;
            }
            .taochan_sj {
              flex: 1;
              text-align: left;
              margin-left: 12px;
              p {
                margin: 0;
              }
              .p_jine {
                flex: 1;
                text-align: left;
                .span1 {
                  width: 10px;
                  height: 20px;
                  font-size: 14px;
                  font-family: DIN-Bold, DIN;
                  font-weight: bold;
                  color: #ff5719;
                  line-height: 19px;
                }
                .span2 {
                  height: 34px;
                  font-size: 28px;
                  font-family: DIN-Bold, DIN;
                  font-weight: bold;
                  color: #ff5719;
                  line-height: 33px;
                }
                .span3 {
                  height: 20px;
                  font-size: 14px;
                  font-family: DIN-Bold, DIN;
                  font-weight: bold;
                  color: #ff5719;
                  line-height: 19px;
                }
              }
            }
          }
          .taochan_foot {
            margin-top: 12px;
            width: 100%;
            height: 40px;
            .xufei_btn {
              width: calc(50% - 6px);
              height: 40px;
              background: #ffffff;
              border-radius: 20px 20px 20px 20px;
              border: 1px solid #b9d5ff;
              font-size: 15px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #0066ff;
              line-height: 18px;
              margin-right: 11px;
            }
            .goumai_btn {
              width: calc(50% - 6px);
              height: 40px;
              background: linear-gradient(137deg, #00b2ff 0%, #0066ff 100%);
              box-shadow: inset 0px 4px 8px 0px #3ac0ff;
              border-radius: 18px 18px 18px 18px;
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              border: none;
            }
          }
        }
      }
    }
  }
  .ckgd_th {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 18px;
    img {
      width: 14px;
      height: 14px;
    }
  }
  .tiyan {
    margin-top: 10px;
    .tiyan_xingneng {
      margin-top: 16px;
      .tiyan_dianliu {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        img {
          width: 80px;
          height: 80px;
        }
        .tiyan_left {
          margin-left: 12px;
          p {
            margin: 0;
            text-align: left;
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
          .title_name {
            height: 21px;
            font-size: 15px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #444444;
            line-height: 21px;
          }
        }
        .tiyan_right {
          margin: 0;
          margin-right: 12px;
        }
      }
    }
  }
}
.zhuce_denglu {
  width: calc(100% - 66px);
  margin: 0 28px 28px 0;
  padding: 0 16px 25px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  /deep/ .van-hairline--top-bottom::after {
    border: none;
  }
  p {
    padding: 16px 0;
  }
  .van-cell-group {
    width: 100%;
    height: 50px;
    background: #f6faff;
    border-radius: 8px 8px 8px 8px;
    margin-bottom: 12px;
    .van-field {
      width: 100%;
      height: 50px;
      background: #f6faff;
      border-radius: 8px 8px 8px 8px;
    }
    .yzm_btn {
      border: none;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #0066ff;
      background: none;
    }
    .yzm_btns {
      border: none;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      background: none;
      color: #999999;
    }
  }
  .denglu_xieyi {
    display: flex;
    align-items: center;
    font-size: 12px;
    margin: 16px auto;
    text-align: left;
    a {
      color: #558bff;
    }
  }
  .denglu_btn {
    width: 100%;
    height: 50px;
    background: #0066ff;
    border-radius: 27px 27px 27px 27px;
    font-size: 17px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 26px;
  }
}
.zhifu {
  padding: 0 16px;
  p {
    padding: 14px 0;
  }
  .zhifu_main {
    .zhifu_taochan {
      height: 24px;
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }
    .zhifu_tianshu {
      margin-left: 10px;
      padding: 0 5px;
      height: 18px;
      background: linear-gradient(200deg, #ffa869 0%, #ff5719 100%);
      border-radius: 4px 4px 4px 4px;
      font-size: 11px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
    }
    .zhifu_fs {
      margin-top: 10px;
      margin-bottom: 10px;
      width: 100%;
      min-height: 24px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      p {
        text-align: left;
        margin: 0 16px;
        font-size: 14px;
      }
      .van-cell--clickable:active {
        background: none;
      }
    }
    .goumai_sl {
      display: flex;
      align-items: center;
      padding: 0 16px 10px;
      span {
        flex: 1;
        text-align: left;
      }
    }
  }

  .xieyi {
    text-align: left;
    margin-left: 16px;
    height: 18px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
  }
  .shouyintai {
    width: 100%;
    min-height: 60px;
    background: #fff;
    .main_zhifu {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px 14px;
      height: 44px;
      background: #fff;

      p {
        flex: 1;
        text-align: left;
        .span1 {
          width: 10px;
          height: 20px;
          font-size: 16px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: #ff5719;
          line-height: 19px;
        }
        .span2 {
          height: 34px;
          font-size: 28px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: #ff5719;
          line-height: 33px;
        }
        .span3 {
          height: 20px;
          font-size: 16px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: #ff5719;
          line-height: 19px;
        }
      }
      .btn {
        border: none;
        width: 152px;
        height: 44px;
        background: #0066ff;
        border-radius: 26px 26px 26px 26px;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
}
.shebei {
  .shebei_main {
    .shebei_check {
      .shebei_title {
        display: flex;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
        }
        .shebei_content {
          margin-left: 16px;
          p {
            margin: 0;
            height: 22px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 22px;
          }
          .p1 {
            height: 22px;
            font-size: 18px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }
        }
      }
    }
    .shebei_foot {
      padding: 16px;
      display: flex;
      align-items: center;
      border-top: 1px solid #f7f7f7;
      .xuanze_quanxuan {
        flex: 1;
      }
      .xuanze_shebei {
        width: 114px;
        height: 44px;
        background: #0066ff;
        border-radius: 26px 26px 26px 26px;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        border: none;
      }
    }
  }
}
/deep/.van-cell__title {
  display: flex;
  align-items: center;
  text-align: left;
  img {
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
}
/deep/.van-cell__value {
  height: 24px;
  font-size: 15px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}
/deep/.van-cell::after {
  border: none;
}
/deep/ .van-hairline--top-bottom::after {
  border: none;
}
</style>